/**
 * Created by zhaoyao on 2021/6/8
 * Desc: 电子学生证
 */

import React, { Component } from 'react'
import {Modal, Card, WingBlank, List, Toast, Tabs, WhiteSpace} from "antd-mobile";
import { fetchGet, fetchPost, fetchPostObj } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { getSearchParams, isObjEmpty } from '../../utils/common'
import { switchUser } from '../../redux/actions/userInfo'
import { Icon, message, Button, Cascader, Avatar } from 'antd'
import {getIntValue, getStrValue, isObjNull } from '../../utils/common'
import './ElectronicApply.css';
import {connect} from 'react-redux'

const { alert } = Modal

class ElectronicCard extends Component {

    componentWillMount() {
        document.title = "电子学生证";
    }

    constructor () {
        super()

        this.state = {
           IMEI: null,
           openId: null,
           electronicCardList: [],
           bindingStuName: '',
           schoolName: '',
           gradeClass: '',
           IMEI: '',
           stuId: '',
        }
    }

    componentDidMount () {
        Toast.loading('努力加载中...', 0)
        this.getElectronicCard()
        //this.onChange()
    }

    render() {
        const {bindingStuName, schoolName, gradeClass, IMEI } = this.state;
        const tabs = [
          { title: '定位' },
          { title: '消息' },
          { title: '我的' },
        ];
        return (
            <div>

                <WhiteSpace />
                <Tabs tabs={tabs} initialPage={2} animated={false} useOnPan={false}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '250px', backgroundColor: '#fff' }}>
                    Content of first tab
                  </div>
                  <div className=" flex_column">
                    <div onClick={()=>{
                                                     this.props.history.push('/xxx/'+12);
                                                 }}>
                                            <div className="flex_row padding_10  bg_white">
                                                 <div className="flex_column">
                                                     <div className="span_14  text_bold">安全提醒</div>
                                                 </div>
                                                 <div  className="flex_center_vertical_end item_flex">
                                                     <Icon type="right" />
                                                 </div>
                                             </div>
                    <div className="notify-item-line"></div>
                    </div>
                    <div onClick={()=>{
                                                     this.props.history.push('/xxx/'+12);
                                                 }}>
                                            <div className="flex_row padding_10  bg_white">
                                                 <div className="flex_column">
                                                     <div className="span_14  text_bold">设备消息</div>
                                                 </div>
                                                 <div  className="flex_center_vertical_end item_flex">
                                                     <Icon type="right" />
                                                 </div>
                                             </div>
                    <div className="notify-item-line"></div>
                    </div>
                  </div>
                  {/*<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '250px', backgroundColor: '#fff' }}>*/}
                  <div  className=" flex_column">
                      <div>

                        <WingBlank size="lg">
                          <WhiteSpace size="lg" />
                          <Card>
                            <Card.Header
                              title={bindingStuName}
                              thumb={bindingStuName ?
                                                                <img className="img-circle flex_row_center"
                                                                     width={78}
                                                                     style={{ marginLeft: '10px' }}
                                                                     src={bindingStuName}
                                                                /> :
                                                                this.props.isSelect ?
                                                                  <Avatar className={this.props.isSelect
                                                                    ? 'border-radius-50-blue'
                                                                    : 'border-radius-50'}
                                                                          size={68} icon='user'/> :
                                                                  <Avatar className={this.props.isSelect
                                                                    ? 'border-radius-50-blue'
                                                                    : 'border-radius-50'}
                                                                          size={68} icon='user'/>
                                                              }
                            />
                            <Card.Body>
                              <div>{schoolName}</div>
                              <div>{gradeClass}</div>
                            </Card.Body>
                            <Card.Footer content={'IMEI：'+IMEI} extra={


                            <div onClick={()=>{
                                                             this.props.history.push('/electronicCardData/'+IMEI);
                                                         }}>
                                                    <div>
                                                         修改资料
                                                    </div>
                            </div>
                            } />
                          </Card>
                          <WhiteSpace size="lg" />
                        </WingBlank>

                      </div>

<div onClick={()=>{
                                 this.props.history.push('/electronicCardOnOff/'+IMEI);
                             }}>
                        <div className="flex_row padding_10  bg_white">
                             <div className="flex_column">
                                 <div className="span_14  text_bold">远程开关</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 {/*<div className="span_14 color_lightGreen">1111</div>*/}
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>
</div>
<div onClick={()=>{
                                 this.props.history.push('/addressBook/'+IMEI);
                             }}>
                        <div className="flex_row padding_10  bg_white">
                             <div className="flex_column">
                                 <div className="span_14  text_bold">通讯录</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>
</div>
<div onClick={()=>{
                                 this.props.history.push('/affectionPhone/'+IMEI);
                             }}>
                        <div className="flex_row padding_10  bg_white">
                             <div className="flex_column">
                                 <div className="span_14  text_bold">亲情号码</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>
</div>
<div onClick={()=>{
                                 this.props.history.push('/sosPhone/'+IMEI);
                             }}>
                        <div className="flex_row padding_10  bg_white">
                             <div className="flex_column">
                                 <div className="span_14  text_bold">SOS号码</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>
</div>

<div onClick={()=>{
                                 this.props.history.push('/noDisturbing/'+IMEI);
                             }}>
                        <div className="flex_row padding_10  bg_white">
                             <div className="flex_column">
                                 <div className="span_14  text_bold">上课免打扰</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>
</div>
<div onClick={()=>{
                                 this.props.history.push('/rechargeDetail/'+12);
                             }}>
                        <div className="flex_row padding_10  bg_white">
                             <div className="flex_column">
                                 <div className="span_14  text_bold">安全守护</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>
</div>
<div onClick={()=>{
                                 this.props.history.push('/rechargeDetail/'+12);
                             }}>
                        <div className="flex_row padding_10  bg_white">
                             <div className="flex_column">
                                 <div className="span_14  text_bold">成员绑定</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>
</div>

                        <div className="flex_row padding_10  bg_white" onClick={() => {this.onClickIcCard()}}>
                             <div className="flex_column">
                                 <div className="span_14  text_bold">学生卡解绑</div>
                             </div>
                             <div  className="flex_center_vertical_end item_flex">
                                 <Icon type="right" />
                             </div>
                         </div>
<div className="notify-item-line"></div>

                  </div>
                </Tabs>
                <WhiteSpace />
            </div>
        )
    }

    onClickIcCard () {

        const { IMEI, stuId } = this.state
        alert('', '解绑后，该学生卡设置的信息将会被清空', [
          {
            text: '取消', onPress: () => {
            },
          },
          {
            text: '确定', onPress: () => {

                Toast.loading('')
                fetchPost(API.ELECTRONIC_CARD_RELIEVE, {
                  IMEI: IMEI,

                }).then((response) => {
                  Toast.hide()
                  console.log('response:' + JSON.stringify(response))
                  if (response.success) {
                    Toast.show(response.data)

                  } else {
                    Toast.fail(response.message, 2)
                  }
                  /*this.backTask = setTimeout(() => {
                      this.props.history.goBack()
                  }, 1000)*/
                }).catch((error) => {
                  Toast.hide()
                  console.log('error:' + JSON.stringify(error))
                })
            },
          },
        ])
      }


  getElectronicCard = () => {
      Toast.loading('', 0);
      const {electronicCardList} = this.state;
      fetchGet(API.ELECTRONIC_CARD_LIST, {
          schoolId: this.props.userInfo.user.schoolId,
          stuId: this.props.userInfo.parent.student.stuId,
      }).then(response => {
          Toast.hide();

          electronicCardList.length = 0;
        if (response && response.data && response.data.rulesList &&
            response.data.rulesList.length > 0) {
            electronicCardList = response.data.rulesList
          }


          this.setState({
                  electronicCardList,
                  bindingStuName: response.data.electronicCard.bindingStuName,
                  schoolName: response.data.electronicCard.schoolName,
                  gradeClass: response.data.electronicCard.gradeClass,
                  IMEI: response.data.electronicCard.imei,
                  stuId: response.data.electronicCard.stu_id
                }, () => {
                  console.log(electronicCardList)
                })
          console.log('electronicCardList', electronicCardList);
      }).catch(error => {
          Toast.hide();

          if (typeof error === 'string') {
              Toast.fail(error, 2)
          } else {
              Toast.fail('请求异常', 2)
          }
      })
  };


}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ElectronicCard)
